var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-2",style:({ cursor: 'url(' + _vm.exitCursor + '), auto'})},[_c('VideoViewer',{attrs:{"url":this.videoUrl,"videoRescaledSize":this.videoRescaledSize}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }